export type BannerMessages = {
  number: string;
  message: string;
};

export enum RegionSector {
  EuropeITOffice = 'EuropeIT-Office',
  EuropeConsumerElectronics = 'EuropeConsumer Electronics',
  EuropeSDA = 'EuropeSDA',
  EuropeMDA = 'EuropeMDA',
  EuropeMobilePhone = 'EuropeMobile Phone',
  BrazilITOffice = 'BrazilIT-Office',
  BrazilConsumerElectronics = 'BrazilConsumer Electronics',
  BrazilMDA = 'BrazilMDA',
  BrazilSDA = 'BrazilSDA',
  BrazilMobilePhone = 'BrazilMobile Phone',
  JapanITOffice = 'JapanIT-Office',
  JapanMobilePhone = 'JapanMobile Phone',
  JapanConsumerElectronics = 'JapanConsumer Electronics',
  JapanSDA = 'JapanSDA',
  JapanMDA = 'JapanMDA',
  TurkeyConsumerElectronics = 'TurkeyConsumer Electronics',
  TurkeySDA = 'TurkeySDA',
  TurkeyITOffice = 'TurkeyIT-Office',
  TurkeyMDA = 'TurkeyMDA',
  IndiaMDA = 'IndiaMDA',
  IndiaITOffice = 'IndiaIT-Office',
  IndiaConsumerElectronics = 'IndiaConsumer Electronics',
}

export type RegionSectorToMessages<T extends string = RegionSector> = {
  [key in T]: { number: string; message: string }[];
};
